import React, { Component, Fragment } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'

import Button from '../../../UniformComponents/Button'
import Panel from '../../../UniformComponents/Panel'
import { stages } from './store'

class InitOptions extends Component {
    downloadOptions = [
        {
            name: 'ppt',
            nextStage: stages.DOWNLOADING,
            label: i18n.t('download.modal.ppt'),
            description: 'Powerpoint slides',
            showAtPage: 'report',
        },
        {
            name: 'raw',
            nextStage: stages.PICK_RAW_FORMATS,
            label: i18n.t('download.modal.raw_data'),
            description: 'Triple-S or CSV',
            showAtPage: 'report',
            hide: (store) => !R.isNil(store.reportStore.questionKey),
        },
        {
            name: 'aggregated',
            nextStage: stages.PICK_AGGREGATED_FORMATS,
            label: i18n.t('download.modal.aggregated'),
            description: 'PDF or Excel',
            showAtPage: 'report',
            hide: (store) => !R.isNil(store.reportStore.questionKey),
        },
        {
            name: 'xlsx',
            nextStage: stages.DOWNLOADING,
            label: i18n.t('download.modal.xlsx.title'),
            description: i18n.t('download.modal.xlsx.description'),
            showAtPage: 'report',
            hide: (store) => R.isNil(store.reportStore.questionKey),
        },
        {
            name: 'csv',
            nextStage: stages.SELECT_DOWNLOAD_OPTIONS,
            label: i18n.t('s_csv'),
            description: '',
            showAtPage: 'survey',
        },
        {
            name: 'pdf',
            nextStage: stages.DOWNLOADING,
            label: i18n.t('s_PDF'),
            description: '',
            showAtPage: 'survey',
        },
    ]

    constructor(props) {
        super(props)
        this.state = {
            selected: null,
        }
    }

    infoIcon = () => (
        <div className="infoIcon">
            <div className="circle">
                <i className="fa-sharp fa-light fa-square-question" />
            </div>
        </div>
    )

    advance = (nextStage) => {
        const { store } = this.props
        const { selected } = this.state
        store.setDownloadType(selected)
        store.setStage(nextStage)
    }

    render() {
        const { onClose, store } = this.props
        const { selected } = this.state
        const downloadOption = this.downloadOptions.find((o) => o.name === selected)
        const { nextStage } = downloadOption ?? stages.INIT_OPTIONS
        return (
            <Fragment>
                <div className="uc-modal__header">
                    <h2>{i18n.t('download.modal.export_options')}</h2>
                    <p className="uc-modal__desc">{i18n.t('download.modal.download_options.subtitle')}</p>
                </div>
                <div className="body">
                    {this.downloadOptions.filter(
                        (o) => (
                            o.showAtPage === store.pageType
                            && (typeof o.hide !== 'function' || !o.hide(store))
                        ),
                    ).map((o) => (
                        <Panel
                            cssClass={`${selected === o.name ? 'active' : ''} downloadOption`}
                            onClick={() => this.setState({ selected: o.name })}
                        >
                            {/* TODO: choose icons */}
                            {/* {this.infoIcon()} */}
                            <h5 style={{ marginTop: 16 }}>{o.label}</h5>
                            {/* TODO: write descriptions */}
                            {o.description.length > 1 && (
                                <div style={{ textAlign: 'center', minHeight: 16 }}>
                                    <span>
                                        {o.description}
                                    </span>
                                </div>
                            )}
                            <div style={{ marginTop: 16, textAlign: 'center' }}>
                                <i className="far fa-check" />
                            </div>
                        </Panel>
                    ))}
                </div>
                <div className="uc-modal__button-panel">
                    <Button
                        label={i18n.t('cancel')}
                        cssClass="tertiary"
                        onClick={onClose}
                    />
                    <Button
                        label={i18n.t('continue')}
                        cssClass="primary"
                        disabled={!selected}
                        onClick={() => this.advance(nextStage)}
                    />
                </div>
            </Fragment>
        )
    }
}

export default InitOptions
